"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMergeDataFromMultipleSources = void 0;
var buildSchemaFromViewConfig_1 = __importDefault(require("../viewConfigSchema/buildSchemaFromViewConfig"));
var alterIdsForRevisionChildren_1 = __importDefault(require("../viewConfigSchema/alterIdsForRevisionChildren"));
var normalizr_1 = require("normalizr");
var merge_1 = __importDefault(require("lodash/merge"));
var stripHibernateArtifactsAndReplaceWithIds_1 = require("../viewConfigSchema/stripHibernateArtifactsAndReplaceWithIds");
var getMergeDataFromMultipleSources = function (viewConfig) {
    var schema = (0, buildSchemaFromViewConfig_1.default)(viewConfig);
    var applyRevisionToAllIds = (0, alterIdsForRevisionChildren_1.default)(viewConfig);
    var mergeDataFromMultipleSources = function (data) {
        return data.reduce(function (prev, jsog) {
            var cleaned = (0, stripHibernateArtifactsAndReplaceWithIds_1.applyAndMarkWildcardEntities)(jsog, viewConfig);
            var revisionsApplied = applyRevisionToAllIds(cleaned);
            var entities = (Array.isArray(jsog) && jsog.length > 0
                ? (0, normalizr_1.normalize)(revisionsApplied, [schema[jsog[0].entityType]])
                : Array.isArray(jsog)
                    ? { entities: {} }
                    : (0, normalizr_1.normalize)(revisionsApplied, schema[jsog.entityType])).entities;
            return (0, merge_1.default)({}, prev, entities);
        }, {});
    };
    return mergeDataFromMultipleSources;
};
exports.getMergeDataFromMultipleSources = getMergeDataFromMultipleSources;
//# sourceMappingURL=index.js.map